import { render, staticRenderFns } from "./Sticks.vue?vue&type=template&id=0335364e&"
import script from "./Sticks.vue?vue&type=script&lang=js&"
export * from "./Sticks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports